var FloatingOneTapContentId;
(function(FloatingOneTapContentId) {
    FloatingOneTapContentId[FloatingOneTapContentId[/**
   * Войти или зарегистрироваться
   */ "SIGN_IN_TO_SERVICE"] = 0] = "SIGN_IN_TO_SERVICE";
    FloatingOneTapContentId[FloatingOneTapContentId[/**
   * Войти в учетную запись сервиса
   */ "SIGN_IN_TO_ACCOUNT"] = 1] = "SIGN_IN_TO_ACCOUNT";
    FloatingOneTapContentId[FloatingOneTapContentId[/**
   * Регистрация на мероприятие
   */ "REGISTRATION_FOR_EVENT"] = 2] = "REGISTRATION_FOR_EVENT";
    FloatingOneTapContentId[FloatingOneTapContentId[/**
   * Подача заявки
   */ "SUBMIT_APPLICATIONS"] = 3] = "SUBMIT_APPLICATIONS";
    FloatingOneTapContentId[FloatingOneTapContentId[/**
   * Оформление заказа в сервисе
   */ "MAKE_ORDER_WITH_SERVICE"] = 4] = "MAKE_ORDER_WITH_SERVICE";
    FloatingOneTapContentId[FloatingOneTapContentId[/**
   * Оформление заказа
   */ "MAKE_ORDER_WITHOUT_SERVICE"] = 5] = "MAKE_ORDER_WITHOUT_SERVICE";
    FloatingOneTapContentId[FloatingOneTapContentId[/**
   * Быстрая регистрация
   */ "FAST_REGISTRATION"] = 6] = "FAST_REGISTRATION";
})(FloatingOneTapContentId || (FloatingOneTapContentId = {}));

export { FloatingOneTapContentId };
